<div class="header-home">
  <div class="header-title-menu">
    <img class="location-icon" [src]="getLogo" alt="" />{{ getTitle }}
  </div>
  <div class="header-user-info">
    <div class="header-sub-menu" (click)="showHideMenu(MenuType.Profile)">
      <div class="profile-photo">
        <img [src]="getProfilePhoto" alt="" />
      </div>
      {{ getCoworkingName }}
    </div>
    <div class="notifications-icon" (click)="showHideMenu(MenuType.Notifications)">
      <img [src]="getNotificationsIcon" alt="" />
    </div>
  </div>
  <div class="backdrop" *ngIf="showMenu" (click)="showHideMenu(MenuType.Profile)"></div>
  <div id="sidenav" class="sidenav" *ngIf="showMenu">
    <div *ngIf="menuContent === MenuType.Profile" class="sidenav-user">
      <div class="sidenav-user-info" (click)="dropdownCoworkingMenu = !dropdownCoworkingMenu">
        <div class="inline">
          <div class="profile-photo">
            <img [src]="getProfilePhoto" alt="" />
          </div>
          <div style="display: flex; flex-direction: column">
            {{ getCoworkingName }}
            <span>{{ getFiscalAddress }}</span>
          </div>
        </div>
        <div *ngIf="!dropdownCoworkingMenu">
          <img [src]="getChevronIcon" />
        </div>
        <div *ngIf="dropdownCoworkingMenu">
          <img [src]="getChevronDownIcon" />
        </div>
      </div>
      <div *ngIf="dropdownCoworkingMenu" class="dropdown-coworking-menu">
        <div *ngFor="let coworking of inactiveCoworkings" class="container-options-coworking">
          <div (click)="changeCoworking(coworking.id)" class="option-coworking">
            <img class="option-coworking-image" [src]="coworking.image || defaultImage" alt="" />
            <div class="option-coworking-info">
              {{ coworking.company_name }}
              <span> {{ coworking.fiscal_address }} </span>
            </div>
          </div>
        </div>
        <div class="container-options-new-coworking" *ngIf="getRole === 'coworking'">
          <span class="section-label">{{
            "coworking-profile.new-coworking" | translate
          }}</span>
          <cowing-list-element [label]="'coworking-profile.add-coworking'" (event)="navigateTo('coworking-register')">
          </cowing-list-element>
        </div>
        <div class="container-options-new-coworking" *ngIf="getRole === 'company' || getRole === 'company-plus'">
          <span class="section-label">{{
            "company-profile.new-company" | translate
          }}</span>
          <cowing-list-element [label]="'company-profile.add-company'" (event)="navigateTo('company-register')">
          </cowing-list-element>
        </div>
      </div>
      <div class="sidenav-user-actions">
        <ng-container *ngIf="getRole === 'coworking'">
          <span class="section-label">{{
            "coworking-profile.my-coworking" | translate
          }}</span>
          <cowing-list-element [label]="'coworking-profile.general-info'" (event)="navigateTo('coworking-info')">
          </cowing-list-element>
          <cowing-list-element [label]="'coworking-profile.spaces'" (event)="navigateTo('coworking-spaces')">
          </cowing-list-element>
          <cowing-list-element [label]="'coworking-profile.services'" (event)="navigateTo('coworking-services')">
          </cowing-list-element>
        </ng-container>
        <ng-container *ngIf="getRole === 'company' || getRole === 'company-plus'">
          <span class="section-label">{{
            "company-profile.my-company" | translate
          }}</span>
          <cowing-list-element [label]="'company-profile.general-info'" (event)="navigateTo('company-info')">
          </cowing-list-element>
          <cowing-list-element [label]="'company-profile.employees'" (event)="navigateTo('company-employees')">
          </cowing-list-element>
          <cowing-list-element *ngIf="getRole === 'company-plus'" [label]="'coworking-profile.spaces'" (event)="navigateTo('company-spaces')">
          </cowing-list-element>
          <cowing-list-element *ngIf="getRole === 'company-plus'" [label]="'coworking-profile.services'" (event)="navigateTo('company-services')">
          </cowing-list-element>
          <cowing-list-element [label]="'company-profile.total-consumption'" (event)="navigateTo('company-home/spendings'); showHideMenu(MenuType.Profile)">
          </cowing-list-element>
        </ng-container>
        <span class="section-label">{{
          "coworking-profile.password" | translate
        }}</span>
        <cowing-list-element [label]="'coworking-profile.change-pwd'" (event)="requestPwdRecovery()">
        </cowing-list-element>
        <span class="section-label">{{
          "coworking-profile.payment-method" | translate
        }}</span>
        <cowing-list-element *ngIf="getRole === 'coworking'" [label]="'coworking-profile.payment-info'"
          (event)="navigateTo('coworking-bank-info')">
        </cowing-list-element>
        <cowing-list-element *ngIf="getRole === 'company' || getRole === 'company-plus'" [label]="'company-profile.payment-info'"
          (event)="navigateTo('company-paymethods')">
        </cowing-list-element>

        <span class="section-label">{{
          "coworking-profile.support" | translate
        }}</span>
        <cowing-list-element [label]="'coworking-profile.terms'"
          (event)="openPage('https://www.cowing.es/terms-and-conditions')"></cowing-list-element>
        <cowing-list-element [label]="'coworking-profile.policy'"
          (event)="openPage('https://www.cowing.es/privacy-policy')"></cowing-list-element>
        <cowing-list-element [label]="'coworking-profile.guidelines'"
          (event)="openPage('https://www.cowing.es/community-guidelines')"></cowing-list-element>
        <cowing-list-element [label]="'coworking-profile.faqs'" (event)="openFaqs()"></cowing-list-element>
      </div>
    </div>
    <div *ngIf="menuContent === MenuType.Notifications" class="sidenav-user">
      <div class="sidenav-notif-info">
        <h3>{{ "sidenav.notifications" | translate }}</h3>
        <img [src]="getCloseIcon" (click)="showHideMenu(MenuType.Profile)" />
      </div>
      <div class="sidenav-user-actions"></div>
    </div>
  </div>
</div>
